import React from "react";
import { Helmet } from "react-helmet-async";

const LifeInsurancePage = () => {
  return (
    <div className="w-full min-h-screen bg-gray-100 p-4">
       <Helmet>
              <title>Kota HOLDINGS</title>
              <meta name="description" content="A Vision of My 30-Year World" />
            </Helmet>
      <div className="mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="bg-[#FF6F00] text-white p-6">
          <h2 className="text-2xl font-bold">We provide the best value Life Insurance</h2>
          <p className="mt-2">Simple steps you can take to improve your financial well-being for the rest of your life.</p>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
            <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
            <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
          </div>
          <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
          <button className="mt-4 bg-blue-600 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Get Quote</button>
        </div>
        <div className="p-6">
          <h1 className="text-2xl md:text-3xl font-bold text-[#FF6F00] mb-4">What is Life Insurance?</h1>
          <p className="mb-4">Life insurance is a financial contract between an individual (the policyholder) and an insurance company...</p>
          <h2 className="text-xl font-bold mt-6 mb-2">Types Of Life Insurance:</h2>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Term Life Insurance:</strong> A long-term, pure financial protection strategy.</li>
            <li><strong>Whole Life Insurance:</strong> Offers lifetime coverage.</li>
            <li><strong>Unit Linked Insurance Plan (ULIP):</strong> Investment-based insurance.</li>
            <li><strong>Endowment Plan:</strong> Ensures a guaranteed payout.</li>
            <li><strong>Money Back Plan:</strong> Helps manage cash flows for major life goals.</li>
            <li><strong>Retirement Plan:</strong> Builds a retirement fund or pension.</li>
            <li><strong>Child Insurance Plan:</strong> Secure your child's education and future.</li>
            <li><strong>Group Insurance Plan:</strong> Covers employees and customers of businesses.</li>
            <li><strong>Savings & Investment Plans:</strong> Helps achieve financial objectives.</li>
          </ul>
          <h2 className="text-xl font-bold mt-6 mb-2">Who should buy a Life Insurance Policy?</h2>
          <ul className="list-disc list-inside mb-4">
            <li>Individuals with financial dependents.</li>
            <li>Breadwinners supporting their household.</li>
            <li>People with outstanding debts.</li>
            <li>Parents securing their children's education.</li>
            <li>Business owners protecting their families.</li>
            <li>Individuals with financial goals like inheritance.</li>
            <li>Those covering funeral and final expenses.</li>
            <li>People seeking investment opportunities through life insurance.</li>
          </ul>
          <h2 className="text-xl font-bold mt-6 mb-2">Learn a few terms about Life Insurance</h2>
          <ul className="list-disc list-inside mb-4">
            <li>Regular payment for the policy.</li>
            <li>Beneficiary who receives the death benefit.</li>
            <li>Payout given upon insured's passing.</li>
            <li>Policy duration and validity.</li>
            <li>Sum of money paid to the beneficiary.</li>
            <li>Risk assessment for policy eligibility.</li>
            <li>Savings component that grows over time.</li>
            <li>Optional add-ons for extra coverage.</li>
            <li>Coverage for a specific period with lower premiums.</li>
            <li>Lifetime coverage with savings benefits.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LifeInsurancePage;
